import { getAllEmpresas, saveEmpresa, updateEmpresa,deleteEmpresa } from '@/services/api/empresa.js';
export const actions = {
  async getAllEmpresas(state) {
    try {
      const dataList = await getAllEmpresas();
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async saveEmpresa(state, payload) {
    try {
      await saveEmpresa(payload);
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async updateEmpresa(state, payload) {
    try {
      await updateEmpresa(payload);
    } catch (error) {
      /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async deleteEmpresa(state, payload) {
    try {
      await deleteEmpresa(payload);
    } catch (error) {
      /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
}
